<template>

    <div class="modal__overlay">

        <div class="modal-config-portada">

            <h3>{{ props.content.id ? $t('image.EDIT_IMAGE_BLOCK') : $t('image.ADD_IMAGE_BLOCK') }}</h3>

            <div v-if="imgUrl" class="file-preview">
                <span class="delete">
                    <i class="material-icons" @click="imgUrl = ''; noChanges = false">delete</i>
                </span>
                <img :src="imgUrl">
            </div>

            <UploadFileDrag v-else
                containerCDN="content"
                @fileUploaded="fileCDN => imgUrl = fileCDN"
                @fileDeleted="imgUrl = ''"
            >
                <!-- <span>Medidas 1600px x 186px - 2 MB</span> -->
            </UploadFileDrag>

            <div class="modal__buttons">
                <button class="cancel" @click.stop="emit('close')">{{ $t('global.CANCEL') }}</button>
                <button class="confirm" @click.stop="save()" :disabled="saving || !imgUrl || noChanges">
                    {{ $t('global.SAVE') }}<i class="material-icons">arrow_forward</i>
                </button>
            </div>

        </div>

    </div>

</template>

<script setup>
import { ref, defineProps, defineEmits, onMounted } from "vue";
import { useStore } from 'vuex';
import UploadFileDrag from '@/components/UploadFileDrag.vue';
import { useI18n } from 'vue-i18n';


const store = useStore();

const props = defineProps({
    content: Object
})
const emit = defineEmits(['reload','close']);

const { t } = useI18n();


const imgUrl = ref('');
const saving = ref(false);
const noChanges = ref(false);

const save = async ()=> { 
    saving.value = true;
    let model = props.content;
    model.data.Data = `<div class="content-image"><img src="${imgUrl.value}"/></div>`;
    try {
        model.id
            ? await store.dispatch('contentEditor_editContent', model)
            : await store.dispatch('contentEditor_createContent', model);
        emit('reload');        
    } catch (error) {
        console.log(error);
        store.dispatch('notifications_create', { text: t('image.ERROR_SAVING_CONTENT') });
    } finally {
        saving.value = false;
    }
}

onMounted(async()=>{
    if(props.content.id){
        let $div = document.createElement('div');
        $div.innerHTML = props.content.data.Data;
        let $img = $div.querySelector('img');
        let $src = $img.getAttribute('src');
        imgUrl.value = $src;
        $div.remove();
        noChanges.value = true;
    }
}) 


</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
@import './commonStyles.scss';


.modal-config-portada{
    @include componentModal;
    max-width: 540px;
    display: flex;
    flex-direction: column;
    gap: 26px;
    .use-portada{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .file-preview{
        position: relative;
        width: 100%;
        text-align: center;
        .delete{
            position: absolute;
            right: 6px;
            top: 8px;
            padding: 6px 6px 2px 6px;
            background: #fff;
            border-radius: 18px;
            cursor: pointer;
            box-shadow: -2px 4px 35px 12px rgba(217, 217, 217, 0.5);
            .material-icons{
                color: red;
            }
        }
        img{
            max-width: 100%;
            height: auto;
            object-fit: contain;
        }
    }
}

.upload-file__container{
    display: inline-block;
    position: relative;
    left: 0;
    text-align: center;
    #upload-file{
        visibility: hidden;
        position: absolute;
        width: 0px;
        height: 0px;
        top: 0;
        left: 0;
    }
    label,span{
        height: 36px;
        width: 181px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        border: 1px solid $green;
        background: #fff;
        border-radius: 44px;
        color: $green;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        .material-icons{
            color: $green;
            font-size: 19px;
        }
    }
}



</style>